import InformationTab from 'components/InformationTab';
import SingleFilter from 'components/SingleFilter';
import TableNavigator from 'components/TableNavigator';
import TableResults from 'components/TableResults';
import VHS_EVENTS_ACTIONS from 'constants/VHS_EVENTS_ACTIONS';
import useActions from 'hooks/useActions';
import useVhsAnalyticsChartData from 'hooks/useVhsAnalyticsChartData';
import { useEffect, useState } from 'react';
import AnalyticsTable from 'routing/vhs/Analytics/AnalyticsTable';

const { connect } = require('react-redux');

function mapStateToProps(state) {
    return {
        selectedSeries: state.vhsSeries.selectedSeries,
        activities: state.vhsSeries.activities,
        activities_total: state.vhsSeries.activities_total,
        isLoading: state.vhsSeries.isLoadingActivity,
        per_page: state.vhsSeries.activities_per_page,
        page: state.vhsSeries.activities_page,
        total_pages: state.vhsSeries.activities_total_pages,
        activitiesFilter: state.vhsSeries.activitiesFilter,
        periodFilter: state.vhsSeries.periodFilter,
        chartData: state.vhsSeries.chartData,
    };
}

const SeriesAnalytics = connect(mapStateToProps)(function (props) {
    const {
        activities,
        per_page,
        page,
        total_pages,
        activities_total,
        activitiesFilter,
        selectedSeries,
        periodFilter,
        chartData,
        isLoading,
    } = props;
    const {
        VHS_FETCH_SERIES_ACTIONS_REQUEST,
        VHS_SELECT_SERIES_ACTIVITIES_FILTER,
        VHS_FETCH_SERIES_ACTIVITY_CHART_REQUEST,
        VHS_SELECT_SERIES_PERIOD_FILTER,
    } = useActions();
    const [parsedChartData, loadParsedChartData] = useVhsAnalyticsChartData();

    const [sectionName, setSectionName] = useState('');
    const [chartName, setChartName] = useState('');

    const onNextPage = () => {
        VHS_FETCH_SERIES_ACTIONS_REQUEST({
            per_page,
            page: page + 1,
            actions: activitiesFilter,
            seriesId: selectedSeries?.id,
        });
    };

    const onPrevPage = () => {
        VHS_FETCH_SERIES_ACTIONS_REQUEST({
            per_page,
            page: page - 1,
            actions: activitiesFilter,
            seriesId: selectedSeries?.id,
        });
    };

    const onPageSelect = (pageSelected) => {
        VHS_FETCH_SERIES_ACTIONS_REQUEST({
            per_page,
            page: pageSelected,
            actions: activitiesFilter,
            seriesId: selectedSeries?.id,
        });
    };

    const onPerPageSelected = ({ perPage }) => {
        VHS_FETCH_SERIES_ACTIONS_REQUEST({
            per_page: perPage,
            actions: activitiesFilter,
            seriesId: selectedSeries?.id,
        });
    };

    const onPeriodSelected = ({ period }) => {
        VHS_SELECT_SERIES_PERIOD_FILTER(period);
        VHS_FETCH_SERIES_ACTIVITY_CHART_REQUEST({
            period,
            actions: activitiesFilter,
            seriesId: selectedSeries?.id,
        });
        const label = VHS_EVENTS_ACTIONS.find(
            (act) => act.value === activitiesFilter
        )?.label;
        setChartName(
            `${
                label === 'All' ? 'All Actions' : label
            } in the last ${period} Days`
        );
    };

    useEffect(() => {
        loadParsedChartData(chartData, activitiesFilter);
        // eslint-disable-next-line
    }, [chartData]);

    useEffect(() => {
        VHS_FETCH_SERIES_ACTIONS_REQUEST({
            per_page: per_page,
            actions: activitiesFilter,
            seriesId: selectedSeries?.id,
        });
        VHS_FETCH_SERIES_ACTIVITY_CHART_REQUEST({
            period: periodFilter,
            actions: activitiesFilter,
            seriesId: selectedSeries?.id,
        });
        const label = VHS_EVENTS_ACTIONS.find(
            (act) => act.value === activitiesFilter
        )?.label;
        setChartName(
            `${
                label === 'All' ? 'All Actions' : label
            } in the last ${periodFilter} Days`
        );
        setSectionName(label === 'All' ? 'All Actions' : label);
        // eslint-disable-next-line
    }, [activitiesFilter]);

    return (
        <section>
            <InformationTab
                sectionName={sectionName}
                chartName={chartName}
                perPage={per_page}
                onPerPageSelected={onPerPageSelected}
                showPrograms={false}
                customFilters={[
                    <SingleFilter
                        selectedValue={activitiesFilter}
                        options={VHS_EVENTS_ACTIONS}
                        onSelect={(value) =>
                            VHS_SELECT_SERIES_ACTIVITIES_FILTER(value)
                        }
                    />,
                ]}
                dataTable={
                    <section>
                        <TableResults results={activities_total} />
                        <AnalyticsTable
                            activities={activities}
                            isLoading={isLoading}
                        />
                        <TableNavigator
                            currentPage={page}
                            totalPages={total_pages}
                            onNext={onNextPage}
                            onPrev={onPrevPage}
                            onPageSelected={onPageSelect}
                        />
                    </section>
                }
                hasChart
                chartData={parsedChartData}
                selectedPeriod={periodFilter}
                onPeriodSelected={onPeriodSelected}
                showBreadcrumbs={false}
            />
        </section>
    );
});

export default SeriesAnalytics;
